import React from "react";

import withStyles from "@material-ui/core/styles/withStyles";
import Chip from "@material-ui/core/Chip";
import Grid from "@material-ui/core/Grid";

import styles from "./styles";

const FutureBadge = ({classes}) => (
  <Grid item>
    <Chip
      label={'geplant'}
      className={classes.chip}
      size={'small'}
    />
  </Grid>
);

export default withStyles(styles)(FutureBadge);